import React from "react";
import { Form } from "antd";
import { useTranslate } from "@refinedev/core";
import { Grid, Toggle } from "@libertify/ui";
import { PlaybookAddOnCard } from "../../PlaybookAddOnCard";
import { PlaybookSelect } from "../../PlaybookSelect";
import { PlaybookFormItem } from "../../PlaybookFormItem";
import { useAddonDraft } from "../../../context/PlaybookDraftContext";
import { KeyPointsFormValues } from "../types";
import { KEY_POINTS_DEFAULTS } from "../defaults";
import { useKeyPointsConfigData } from "../hooks/useKeyPointsConfigData";
import { CONFIG_ITEM } from "../../../data/addons";

// TODO: replace with a real credit estimate once the backend exposes one for
// this add-on. Hardcoded for now (matches the catalog placeholder).
const ESTIMATED_CREDITS = 50;

/**
 * Settings card for the "Key points" playbook add-on — a frontend-only name
 * for the backend `Summary` add-on type (see `KeyPointsFormValues`).
 */
export const KeyPointsConfigCard: React.FC = () => {
  const t = useTranslate();
  const [form] = Form.useForm<KeyPointsFormValues>();
  const { lengthOptions, formatOptions, readingLevelOptions } =
    useKeyPointsConfigData();
  const { initialValues, onValuesChange } = useAddonDraft(
    CONFIG_ITEM.Summary,
    KEY_POINTS_DEFAULTS
  );

  return (
    <PlaybookAddOnCard
      itemId={CONFIG_ITEM.Summary}
      title={t("createExperience.addOns.keyPoints.title")}
      credits={ESTIMATED_CREDITS}
      description={t("createExperience.addOns.keyPoints.description")}
    >
      <Form<KeyPointsFormValues>
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <Grid columns={2} gap="lg">
          <PlaybookFormItem
            name={["generation_settings", "length"]}
            labelKey="createExperience.addOns.keyPoints.length.label"
          >
            <PlaybookSelect options={lengthOptions} />
          </PlaybookFormItem>
          <PlaybookFormItem
            name={["generation_settings", "format"]}
            labelKey="createExperience.addOns.keyPoints.format.label"
          >
            <PlaybookSelect options={formatOptions} />
          </PlaybookFormItem>

          <PlaybookFormItem
            name={["generation_settings", "reading_level"]}
            labelKey="createExperience.addOns.keyPoints.readingLevel.label"
          >
            <PlaybookSelect options={readingLevelOptions} />
          </PlaybookFormItem>
          <PlaybookFormItem
            name={["generation_settings", "separate_into_chapters"]}
            labelKey="createExperience.addOns.keyPoints.separateIntoChapters"
            valuePropName="checked"
          >
            <Toggle size="l" />
          </PlaybookFormItem>

          <PlaybookFormItem
            name={["generation_settings", "include_key_take_aways"]}
            labelKey="createExperience.addOns.keyPoints.includeKeyTakeaways"
            valuePropName="checked"
          >
            <Toggle size="l" />
          </PlaybookFormItem>
        </Grid>
      </Form>
    </PlaybookAddOnCard>
  );
};

export default KeyPointsConfigCard;
